'use strict';

var series = require('async/series');

var promisify = require('promisify-es6');

module.exports = function (self) {
  return promisify(function (callback) {
    callback = callback || function noop() {};

    self.log('stop');

    if (self.state.state() === 'stopped') {
      return callback(new Error('Already stopped'));
    }

    if (self.state.state() !== 'running') {
      return callback(new Error('Not able to stop from state: ' + self.state.state()));
    }

    var done = function done(err) {
      if (err) {
        self.emit('error', err);
        return callback(err);
      }

      self.state.stopped();
      self.emit('stop');
      callback();
    };

    self.state.stop();

    self._blockService.unsetExchange();

    self._bitswap.stop();

    self._preload.stop();

    series([function (cb) {
      return self._ipns.republisher.stop(cb);
    }, function (cb) {
      return self._mfsPreload.stop(cb);
    }, function (cb) {
      return self.libp2p.stop(cb);
    }, function (cb) {
      return self._repo.close(cb);
    }], done);
  });
};